<div class="in_vitro_fertilization header_top mb-5">
  <section class="treatment_banner">
    <div class="container">
      <div class="banner_content">
        <h6>Recurrent Pregnancy Loss (RPL) Treatment</h6>
        <p>
          Expert care at NCare IVF Kannur, Kerala to diagnose and treat
          recurrent pregnancy loss, helping you achieve a healthy pregnancy.
        </p>
        <button [routerLink]="['/contact-us']">Book a Consultation</button>
      </div>
    </div>
  </section>
  <section class="how_does_work_ivf mt-5">
    <div class="container">
      <div class="row aic">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/rpl/causes__ecurrent_regnancy_oss.webp"
            alt=""
          />
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12">
          <h6>What is Recurrent Pregnancy Loss (RPL)?</h6>
          <p>
            Recurrent Pregnancy Loss (RPL) is the loss of two or more
            consecutive pregnancies before 20 weeks of gestation. Unlike
            isolated miscarriages, RPL often indicates an underlying medical
            condition that requires detailed assessment.
          </p>
          <p>
            While miscarriage can be an emotionally challenging experience,
            repeated pregnancy losses require specialized medical attention to
            determine the cause and improve future pregnancy outcomes.
          </p>
          <p>
            We provide comprehensive diagnostic evaluations, advanced fertility
            treatments, and personalized care to help couples achieve successful
            pregnancies.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="timeline">
    <div class="container">
      <div class="timeline-block">
        <h2>How Common is Recurrent Pregnancy Loss?</h2>
        <p>
          Recurrent Pregnancy Loss (RPL) affects about
          <strong>1% of couples</strong> trying to conceive. Potential causes
          include genetic abnormalities, hormonal imbalance, immune system
          issues, or uterine defects. With early diagnosis and treatment, many
          couples achieve a healthy pregnancy.
        </p>
      </div>
    </div>
  </section>
  <section class="diagonal-section">
    <div class="image-side"></div>
    <div class="text-side">
      <h2>When Should You Seek Medical Help?</h2>
      <ul>
        <li>Two or more consecutive miscarriages before 20 weeks</li>
        <li>A history of stillbirths or failed IVF cycles</li>
        <li>Previous pregnancy losses with no known cause</li>
        <li>Difficulty conceiving after multiple losses</li>
      </ul>
      <p>
        Early diagnosis and intervention can improve pregnancy success rates and
        reduce future risks.
      </p>
    </div>
  </section>
  <section class="rpl_help mt-5">
    <div class="container">
      <div class="card">
        <h2>How NCare IVF Kannur, Kerala Helps in Managing RPL</h2>
        <p>
          We take a comprehensive approach to identifying and treating the
          causes of RPL. Our goal is to help couples achieve a healthy,
          full-term pregnancy through specialized fertility care.
        </p>
        <ul class="features">
          <li>Advanced diagnostic tests to determine the root cause</li>
          <li>
            Personalized treatment plans tailored to each patient’s medical
            history
          </li>
          <li>
            Innovative reproductive techniques to improve implantation success
          </li>
          <li>
            Holistic fertility support to enhance overall reproductive health
          </li>
        </ul>
      </div>
    </div>
  </section>

  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <!-- <h5>CTA Banner</h5> -->
        <p>Personalized, Evidence-Based Care for Recurrent Pregnancy Loss</p>
        <p>
          Our individualized treatment plans give you the best chance to
          overcome RPL and achieve a healthy pregnancy.
        </p>
        <button [routerLink]="['/contact-us']">Book a consultation</button>
      </div>
    </div>
  </section>
  <section class="causes_recurrent_pregnancy_loss mt-5">
    <div class="container">
      <h1 class="title_header tac">Causes of Recurrent Pregnancy Loss (RPL)</h1>
      <p class="title_para">
        Recurrent pregnancy loss can result from various medical, genetic, and
        lifestyle factors. Understanding the cause is crucial in developing an
        effective treatment plan. At NCare IVF Kannur, Kerala, we perform a
        detailed evaluation to diagnose and address the underlying reasons for
        multiple miscarriages.
      </p>

      <div *ngFor="let item of causes; let i = index" class="accordion-item">
        <div class="accordion-header" (click)="toggle(i)">
          {{ i + 1 }}. {{ item.title }}
        </div>
        <div
          class="accordion-content"
          [style.display]="activeIndex === i ? 'block' : 'none'"
        >
          <ul>
            <li *ngFor="let point of item.points">{{ point }}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="diagnostic_text_recurrent_pregnancy_loss mt-5">
    <div class="container">
      <div class="diagnostic_text_recurrent_pregnancy_loss_child">
        <h1 class="title_header tac">
          Diagnostic Tests for Recurrent Pregnancy Loss (RPL) at NCare IVF
        </h1>
        <p class="title_para">
          We use a comprehensive set of diagnostic tests to determine the root
          cause of recurrent pregnancy loss. Identifying the underlying issue
          allows us to develop a targeted treatment plan for improving pregnancy
          success.
        </p>

        <div class="grid">
          <div class="card">
            <h2>Genetic Testing (Karyotyping & PGT)</h2>
            <ul>
              <li>Parental karyotyping to identify genetic disorders</li>
              <li>PGT-A/PGT-M to ensure chromosomally normal embryos</li>
            </ul>
          </div>

          <div class="card">
            <h2>Hysteroscopy & 3D Ultrasound</h2>
            <ul>
              <li>Detects fibroids, polyps, and uterine anomalies</li>
              <li>3D imaging for structural assessment</li>
            </ul>
          </div>

          <div class="card">
            <h2>Hormonal & Thyroid Tests</h2>
            <ul>
              <li>Evaluates estrogen, progesterone, and thyroid levels</li>
              <li>Identifies PCOS or luteal phase defects</li>
            </ul>
          </div>

          <div class="card">
            <h2>Thrombophilia Screening</h2>
            <ul>
              <li>Detects blood clotting issues like APS or Factor V Leiden</li>
              <li>Determines need for anticoagulant therapy</li>
            </ul>
          </div>

          <div class="card">
            <h2>Infection Screening</h2>
            <ul>
              <li>Checks for CMV, rubella, toxoplasmosis, and endometritis</li>
              <li>Prevents complications via early treatment</li>
            </ul>
          </div>

          <div class="card">
            <h2>Immune System Evaluation</h2>
            <ul>
              <li>Assesses NK cells, cytokines, and autoimmune markers</li>
              <li>Supports immune-targeted therapies if needed</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="target_treatment_recurrent_pregnancy_loss mt-5">
    <div class="container">
      <h1 class="title_header tac">
        Targeted Treatments for Recurrent Pregnancy Loss
      </h1>
      <p class="title_para">
        At NCare IVF, we tailor treatments for RPL through genetic evaluation,
        hormonal balance, immune regulation, and uterine health optimization.
      </p>

      <div class="grid">
        <div class="card">
          <h2>Genetic Evaluation & Embryo Selection</h2>
          <ul>
            <li>
              <strong>PGT-A & PGT-M:</strong> Selects healthy embryos to reduce
              miscarriage risk.
            </li>
            <li>
              <strong>Parental Karyotyping:</strong> Detects genetic conditions
              for informed treatment.
            </li>
          </ul>
        </div>

        <div class="card">
          <h2>Optimizing Endometrial Health</h2>
          <ul>
            <li>
              <strong>ERA:</strong> Identifies the best window for implantation.
            </li>
            <li>
              <strong>PRP Therapy & Scratch:</strong> Enhances uterine
              receptivity.
            </li>
          </ul>
        </div>

        <div class="card">
          <h2>Hormonal & Metabolic Balance</h2>
          <ul>
            <li>
              <strong>Progesterone & Estrogen:</strong> Stabilize early
              pregnancy.
            </li>
            <li>
              <strong>Thyroid & PCOS Management:</strong> Supports implantation
              and growth.
            </li>
          </ul>
        </div>

        <div class="card">
          <h2>Blood Clotting & Immune Management</h2>
          <ul>
            <li>
              <strong>Aspirin & Heparin:</strong> Improve uterine blood flow.
            </li>
            <li>
              <strong>Immunotherapy & IVIG:</strong> Prevent embryo rejection.
            </li>
          </ul>
        </div>

        <div class="card">
          <h2>Structural Uterine Correction</h2>
          <ul>
            <li>
              <strong>Hysteroscopic Surgery:</strong> Removes fibroids, polyps,
              and scar tissue.
            </li>
          </ul>
        </div>

        <div class="card">
          <h2>Holistic Fertility Support</h2>
          <ul>
            <li>
              <strong>Nutritional Guidance:</strong> Promotes fertility-friendly
              habits.
            </li>
            <li>
              <strong>Mind-Body Therapies:</strong> Yoga, meditation,
              acupuncture for emotional wellness.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="success_rate_treatment_outcomes mt-5">
    <div class="container">
      <h1 class="title_header tac">Success Rates & Treatment Outcomes</h1>
      <p class="title_para">For Recurrent Pregnancy Loss at NCare IVF</p>

      <p class="title_para">
        Our advanced diagnostic and treatment strategies significantly enhance
        the chances of a successful pregnancy. By identifying the root cause of
        recurrent pregnancy loss (RPL) and implementing personalized treatment
        plans, we have helped many couples achieve full-term pregnancies.
      </p>

      <section class="treatments">
        <h2>How Our Treatments Improve Pregnancy Success</h2>

        <div class="card">
          <h3>Genetic Screening & Embryo Selection</h3>
          <p>
            <strong>Preimplantation Genetic Testing (PGT)</strong> increases the
            live birth rate by <strong>60–70%</strong> in couples with
            chromosomal-related miscarriages.
          </p>
        </div>

        <div class="card">
          <h3>Hormonal & Endometrial Support</h3>
          <p>
            Proper hormone regulation and endometrial treatments reduce the risk
            of pregnancy loss by <strong>50%</strong>.
          </p>
        </div>

        <div class="card">
          <h3>Thrombophilia & Immune System Management</h3>
          <p>
            <strong>Blood clotting treatments</strong> (Heparin & Aspirin)
            prevent pregnancy loss in <strong>80%</strong> of cases related to
            clotting disorders.
          </p>
          <p>
            <strong>Immunotherapy</strong> significantly improves implantation
            rates in cases of immune-related pregnancy loss.
          </p>
        </div>
      </section>

      <section class="stories">
        <h2>Patient Success Stories</h2>
        <p>
          At NCare IVF, we have helped numerous couples overcome the challenges
          of RPL. Our evidence-based approach, experienced specialists, and
          advanced technology have led to high success rates and healthy
          pregnancies.
        </p>
        <p>
          Every case is unique, and we ensure tailored treatments to maximize
          the chances of a full-term pregnancy.
        </p>
        <p>
          By combining cutting-edge reproductive medicine with personalized
          fertility care, NCare IVF Kannur, Kerala provides hope and results for
          couples facing recurrent pregnancy loss.
        </p>
      </section>
    </div>
  </section>
  <section class="why_choose_ncare_ivf_kannur mt-5">
    <div class="container">
      <h4 class="title_header tac">Why Choose NCare IVF in Kannur?</h4>
      <p class="title_para">
        Finding the right IVF treatment in Kannur is crucial for your fertility
        journey. At NCare IVF, we combine cutting-edge <br />
        technology, expert fertility care, and a supportive environment to
        maximize your chances of success.
      </p>
      <div class="row">
        <span></span>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/rpl/rplt_1.svg"
              alt=""
            />
            <h5>Dedicated RPL Care Center</h5>
            <p>
              We offer comprehensive evaluation and treatment plans specifically
              designed for couples facing repeated pregnancy loss.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/rpl/rplt_2.svg"
              alt=""
            />
            <h5>Experienced Fertility Specialists</h5>
            <p>
              Expert diagnosis and personalized care for complex fertility
              challenges.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/rpl/rplt_3.svg"
              alt=""
            />
            <h5>Advanced Diagnostic Approach</h5>
            <p>
              Comprehensive testing including genetic, hormonal, and uterine
              evaluations.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/rpl/rplt_4.svg"
              alt=""
            />
            <h5>Tailored Treatment Strategies</h5>
            <p>
              Includes PGT, ERA, and therapies to enhance implantation success.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/rpl/rplt_5.svg"
              alt=""
            />
            <h5>Comprehensive Patient Support</h5>
            <p>
              Continuous monitoring, counseling, and emotional support
              throughout your journey.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/rpl/rplt_6.svg"
              alt=""
            />
            <h5>Convenient Location in Kannur</h5>
            <p>
              Trusted reproductive care close to home, in the heart of Kerala.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq mt-5">
    <h4 class="title_header tac">Frequently Asked Questions</h4>
    <div class="container">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              How is Recurrent Pregnancy Loss (RPL) diagnosed?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              RPL is diagnosed when a woman experiences two or more consecutive
              pregnancy losses before 20 weeks of gestation. A thorough
              evaluation, including genetic testing, hormone analysis, immune
              system assessment, and uterine imaging, helps identify the cause.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Can recurrent pregnancy loss be prevented?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Yes, many cases of RPL can be prevented with proper diagnosis and
              personalized treatment. Depending on the underlying cause,
              strategies such as genetic screening, hormonal therapy, blood
              clotting management, or immune therapy can help improve pregnancy
              outcomes.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How does genetic testing help in preventing miscarriage?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Genetic abnormalities in embryos or parents are a common cause of
              pregnancy loss. Preimplantation Genetic Testing (PGT) screens
              embryos before implantation, ensuring only healthy embryos are
              transferred, reducing the risk of miscarriage.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              What lifestyle changes can help reduce the risk of miscarriage?
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <ul>
                <li>Maintain a healthy weight with a balanced diet.</li>
                <li>Avoid smoking, alcohol, and excessive caffeine intake.</li>
                <li>
                  Manage stress and anxiety through relaxation techniques.
                </li>
                <li>
                  Follow your doctor’s recommendations for prenatal care and
                  supplements.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              How long should I wait before trying to conceive again after a
              miscarriage?
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              The recommended waiting period varies based on individual
              circumstances. Most doctors suggest waiting at least 2-3 months to
              allow for physical and emotional recovery before attempting
              conception again.
            </div>
          </div>
        </div>
      </div>
      <button class="contact_us_info" (click)="contactus()">
        Contact Us for more information
      </button>
    </div>
  </section>
</div>
